const t = (r) => {
  const e = typeof r == "number" ? r : Number(r);
  return e ? `${e}%` : "0%";
};
export {
  t as formatPercentage
};
